import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  selectClientConfig,
  selectIdentityClientSubscriptionData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { updateClientData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { selectAuthData, selectEnergyAuthCommonData } from '@/containers/Login/AuthSelectors'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import useModal from '@/shared/hooks/v2/useModal'

const useIdentity = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { country } = useSelector(selectAuthData)
  const { formIsLoaded, zohoIsInValid, isEditable } = useFormStatus()
  // @ts-ignore
  const customerConfig = modulesConfig[country]?.customer ?? {}
  const { isOpen, openModal, closeModal } = useModal({
    selector: selectClientConfig,
    // @ts-ignore
    actionCreator: data => updateClientData({ data, name: 'config' }),
    modalKey: 'identityModal',
  })
  const { documentTypeOptions: documentTypeOptionsRaw } = useSelector(selectEnergyAuthCommonData) ?? {}
  const documentTypeOptions = Object.keys(documentTypeOptionsRaw ?? {})

  const {
    documentType,
    documentNumber,
    expirationDate = '',
    createdDate = '',
    issuingEntity,
    issuingCity,
  } = useSelector(selectIdentityClientSubscriptionData) ?? {}

  const updateIdentity = (data: object) => {
    // @ts-ignore
    dispatch(updateClientData({ data, name: 'identity' }))
  }

  return {
    t,
    formIsLoaded,
    zohoIsInValid,
    isEditable,
    hidden: !customerConfig.identity,
    isOpen,
    openModal,
    closeModal,
    documentType,
    documentNumber,
    expirationDate: expirationDate ? new Date(expirationDate) : '',
    createdDate: createdDate ? new Date(createdDate) : '',
    issuingEntity,
    issuingCity,
    documentTypeOptions,
    updateIdentity,
  }
}

export default useIdentity
